import { LOTTO, lottoDraw, lottoMatches, lottoWeekDrawn } from '../state/rules';
import type { GameServices } from './services';

/**
 * Mega Bucks: every Saturday at 8 PM the numbers come up (the same numbers for
 * everybody, so you can compare tickets with the neighbors). Checks your tickets and
 * pays out, even if you slept through the drawing.
 */
export class Lotto {
  private timer = 0;

  constructor(private readonly s: GameServices) {}

  update(dt: number): void {
    this.timer -= dt;
    if (this.timer > 0) return;
    this.timer = 2;
    const { store, ui, rng } = this.s;
    const drawn = lottoWeekDrawn(store.day, store.minutes);
    if (drawn < 1) return;
    // Everyone hears the numbers, ticket or not.
    if (Number(store.flag('lotto_seen') ?? 0) < drawn) {
      store.setFlag('lotto_seen', drawn);
      const nums = lottoDraw(drawn);
      ui.hud.pushTicker(
        `LOTTERY: Tonight's Mega Bucks numbers are ${nums.join(' · ')}. Somebody's cousin swears they almost won.`,
      );
      const l = store.state.lotto;
      if (l.week !== drawn || l.tickets.length === 0) return;
      let total = 0;
      let best = 0;
      for (const t of l.tickets) {
        const m = lottoMatches(t, nums);
        best = Math.max(best, m);
        total += LOTTO.prizes[m] ?? 0;
      }
      const count = l.tickets.length;
      l.tickets = [];
      l.week = drawn + 1;
      if (total > 0) {
        store.earn(total);
        store.incr('lottoWins');
      }
      if (best >= 5) {
        store.unlock('jackpot');
        store.headline(
          `LOTTERY: ${store.state.player.name.toUpperCase()} of Lucky Acres hits the $50,000 Mega Bucks jackpot. Already bought a boat. Doesn't own a lake`,
        );
        this.s.sfx('airhorn');
        this.s.share({ kind: 'fireworks', x: this.s.player.position.x, z: this.s.player.position.z + 3 });
      }
      ui.modal.show({
        title: 'Mega Bucks Drawing',
        art: best >= 5 ? ':moneybag:' : best >= 3 ? ':eight-ball:' : ':tv:',
        text:
          `The lady on Channel 6 pulls the balls: ${nums.join(' · ')}.\n\n` +
          (total > 0
            ? best >= 5
              ? `ALL FIVE. ALL FIVE! You scream so loud Tank starts howling. $${total.toLocaleString()} is yours. Darlene already knows. Everybody already knows.`
              : `Your best ticket matched ${best}. That's $${total.toLocaleString()} across your ${count} ticket${count > 1 ? 's' : ''}. ${rng.pick(['Not retirement money. Beer money, though.', 'Lucky called. He wants to "talk investments."', 'You frame the ticket. Then you remember you have to cash it.'])}`
            : `None of your ${count} ticket${count > 1 ? 's' : ''} matched more than ${best}. ${rng.pick(["There's always next Saturday.", 'The lady on Channel 6 looks right at you and smiles. She knows.', 'You were one number off. You were three numbers off. Same thing.'])}`),
        choices: [],
        leave: best >= 5 ? 'I AM RICH' : 'Next week for sure',
      });
    }
  }
}
